/* Progressive enhancement: all content stays readable when JavaScript is unavailable. */
(() => {
  function polishProducts(scope) {
    scope.querySelectorAll('[data-ee-companion-description]').forEach(copy=>{
      const heading=[...copy.querySelectorAll('h1,h2,h3,h4,h5,h6')].find(h=>/frequently asked questions/i.test(h.textContent));
      if(heading){let part=heading;while(part.parentElement!==copy)part=part.parentElement;while(part){const next=part.nextElementSibling;part.hidden=true;part=next;}}
    });
    scope.querySelectorAll('.ee:has(.ee-products-with-copy)').forEach(section=>section.classList.add('ee-companion-section'));
  }
  function productInteractions(scope){
    scope.querySelectorAll('.ee-companion-section').forEach(section=>{
      const copy=section.querySelector('.ee-copy');const heading=section.querySelector('.ee-inner>h2');
      if(copy&&heading){const panel=document.createElement('div');panel.className='ee-companion-copy-panel';copy.before(panel);panel.append(heading,copy);}
    });
    scope.querySelectorAll('[data-ee-product-card]').forEach(card=>{
      if(card.dataset.ready)return;card.dataset.ready='true';
      const preview=()=>{const copy=card.closest('.ee-companion-section')?.querySelector('.ee-companion-copy-panel .ee-copy');if(copy){copy.replaceChildren(card.querySelector('[data-ee-product-copy]').content.cloneNode(true));polishProducts(copy);}};
      card.addEventListener('mouseenter',preview);card.addEventListener('focusin',preview);
      card.querySelector('[data-ee-quick-view]').addEventListener('click',()=>{
        const dialog=document.createElement('dialog');dialog.className='ee-modal ee-quick-view';dialog.setAttribute('aria-label',card.querySelector('h3').textContent);
        const close=document.createElement('button');close.type='button';close.textContent='×';close.className='ee-quick-close';close.setAttribute('aria-label','Close quick view');
        dialog.append(close,card.querySelector('[data-ee-quick-content]').content.cloneNode(true));document.body.append(dialog);
        const dismiss=()=>{dialog.close();dialog.remove();card.querySelector('[data-ee-quick-view]').focus({preventScroll:true});};close.addEventListener('click',dismiss);dialog.addEventListener('cancel',e=>{e.preventDefault();dismiss();});dialog.showModal();setupQuickOrder(dialog);
      });
    });
  }
  function setupQuickOrder(dialog){
    const form=dialog.querySelector('[data-ee-quick-order]');if(!form)return;
    const inputs=[...form.querySelectorAll('[data-variant-id]')],rows=[...form.querySelectorAll('.ee-quick-row')];let page=0;
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:window.Shopify?.currency?.active||'AUD'}).format(cents/100);
    const tiers=JSON.parse(document.querySelector('[data-ee-tiers]')?.dataset.eeTiers||'[]').sort((a,b)=>a.minimum-b.minimum);
    const render=()=>{const limit=Math.max(1,Math.min(6,Math.floor((innerHeight-(innerWidth<650?490:450))/64)));const pages=Math.ceil(rows.length/limit);page=Math.min(page,Math.max(0,pages-1));rows.forEach((r,i)=>r.hidden=i<page*limit||i>=(page+1)*limit);form.querySelector('.ee-quick-pages').hidden=pages<=1;form.querySelector('[data-page]').textContent=`${page+1} / ${pages}`;form.querySelector('[data-previous]').disabled=page===0;form.querySelector('[data-next]').disabled=page===pages-1;};
    const photo=dialog.querySelector('.ee-quick-photo img'),defaultPhoto=photo.src;
    rows.forEach(row=>{const select=()=>{rows.forEach(r=>r.classList.toggle('is-selected',r===row));photo.removeAttribute('srcset');photo.src=row.dataset.image||defaultPhoto;photo.alt=row.dataset.image?row.dataset.size+' — '+dialog.querySelector('h2').textContent:dialog.querySelector('h2').textContent;};row.addEventListener('click',select);row.addEventListener('focusin',select);});
    form.querySelector('[data-previous]').onclick=()=>{page--;render();};form.querySelector('[data-next]').onclick=()=>{page++;render();};
    const update=()=>{let total=0;inputs.forEach(i=>{total+=Math.max(0,Math.floor(Number(i.value)||0))*Number(i.dataset.price);});form.querySelector('[data-total]').textContent=money(total);const tier=tiers.filter(t=>total>=t.minimum).at(-1);form.querySelector('[data-quick-savings]').textContent=tier?`${tier.percent}% volume discount · Save ${money(Math.round(total*tier.percent/100))} · After discount ${money(total-Math.round(total*tier.percent/100))}`:'';};
    inputs.forEach(i=>i.addEventListener('input',update));render();update();window.addEventListener('resize',render);dialog.addEventListener('close',()=>window.removeEventListener('resize',render),{once:true});
    form.addEventListener('submit',async e=>{e.preventDefault();const items=inputs.filter(i=>!i.disabled&&Number(i.value)>0).map(i=>({id:Number(i.dataset.variantId),quantity:Math.floor(Number(i.value))}));const status=form.querySelector('[data-quick-status]'),button=form.querySelector('[type=submit]');if(!items.length){status.textContent='Enter a quantity for at least one size.';return;}button.disabled=true;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add these quantities.');location.href=(window.Shopify?.routes?.root||'/')+'cart';}catch(error){status.textContent=error.message;button.disabled=false;}});
  }
  polishProducts(document);productInteractions(document);
  if(document.querySelector('.ee-main')){
    document.body.classList.add('ee-preview-product');
    document.addEventListener('click',event=>{if(!event.target.closest('[data-ee-sticky-volume]'))return;const dialog=document.querySelector('[data-ee-bulk]');if(dialog&&!dialog.open)dialog.showModal();});
    let fade;
    const revealBar=()=>{
      document.body.classList.add('ee-scrolling');clearTimeout(fade);
      // The native bar controls when it appears; do not fade usable purchase controls.
    };
    document.addEventListener('scroll',revealBar,{capture:true,passive:true});
    const connectBar=()=>{
      const bar=document.querySelector('.sticky-atc-bar__inner');
      const template=document.querySelector('[data-ee-sticky-volume-template]');
      if(!bar||!template||bar.querySelector('[data-ee-sticky-volume]'))return;
      (bar.querySelector('.product-form__buttons') || bar).append(template.content.cloneNode(true));
      bar.querySelector('[data-ee-sticky-volume]').addEventListener('click',()=>{
        const dialog=document.getElementById(template.dataset.dialog);
        if(dialog&&!dialog.open)dialog.showModal();
      });
      bar.addEventListener('pointerenter',()=>clearTimeout(fade));
      bar.addEventListener('pointerleave',revealBar);
      bar.addEventListener('focusin',()=>clearTimeout(fade));
      bar.addEventListener('focusout',revealBar);
      revealBar();
    };
    connectBar();
    new MutationObserver(connectBar).observe(document.body,{childList:true,subtree:true});
  }
  function init(hub) {
    if (hub.dataset.eeReady) return;
    hub.dataset.eeReady = 'true';
    const facts=hub.querySelector('.ee-facts');const factsColumn=hub.querySelectorAll('.ee-about-column')[1];if(facts&&factsColumn){facts.classList.add('ee-column-facts');factsColumn.prepend(facts);}
    {
      const nav=hub.querySelector('.ee-tabs');
      const addStudyTab=(label,content,key)=>{
        const panel=document.createElement('div');panel.id=hub.id+'-'+key;panel.dataset.eePanel='';panel.className='ee-study-extra';if(key==='comparison'){panel.classList.add('ee-comparison-panel');const photo=hub.querySelector('[data-ee-comparison-image]');if(photo)panel.append(photo.content.cloneNode(true));}
        const heading=document.createElement('h2');heading.textContent=label;panel.append(heading,content);
        const tab=document.createElement('a');tab.href='#'+panel.id;tab.dataset.eeTab='';tab.textContent=label;if(key==='comparison')nav.children[0]?.after(tab);else nav.append(tab);hub.querySelector('.ee-inner').append(panel);
      };
      const label=[...hub.querySelectorAll('[data-ee-description] strong')].find(e=>/^Flash or Hillii\?$/i.test(e.textContent.trim()));
      if(label){const paragraph=label.closest('p');const title='Ficus hillii or Flash?';const frame=paragraph.parentElement;label.remove();paragraph.removeAttribute('style');addStudyTab(title,paragraph,'comparison');if(frame!==hub.querySelector('[data-ee-description]')&&!frame.textContent.trim())frame.remove();}
      const studyFacts=hub.querySelector('.ee-facts,.ee-study-facts');
      if(studyFacts?.children.length && hub.classList.contains('ee-study-hub')){
        const content=document.createElement('section');content.className='ee-about-summary';content.append(studyFacts);
        addStudyTab('Tree at a glance',content,'facts');
        const factsPanel=hub.querySelector('#'+CSS.escape(hub.id+'-facts'));factsPanel.classList.add('ee-facts-panel');
        const photo=hub.querySelector('[data-ee-facts-photo]');if(photo)factsPanel.append(photo.content.cloneNode(true));
        const factTab=nav.lastElementChild;nav.children[0]?.after(factTab);
      }
      hub.querySelectorAll('[data-group="uses"] .ee-copy').forEach(copy=>{
        const lists=copy.querySelectorAll('ul');
        lists[0]?.classList.add('ee-garden-use-list');
        lists.forEach(list=>list.querySelectorAll('li').forEach(item=>{
          const text=item.textContent;const split=text.search(/\s[–—]\s/);
          if(split>0){const label=document.createElement('strong');label.textContent=text.slice(0,split);item.replaceChildren(label,document.createTextNode(text.slice(split)));}
        }));
      });
    }
    hub.querySelectorAll('a[data-ee-tab]').forEach(link=>{
      const button=document.createElement('button');button.type='button';button.dataset.eeTab='';button.dataset.eeTarget=link.hash;button.textContent=link.textContent;link.replaceWith(button);
    });
    const tabs = [...hub.querySelectorAll('[data-ee-tab]')];
    const panels = [...hub.querySelectorAll('[data-ee-panel]')];
    // Move the existing FAQ subtree intact; never rewrite the product description.
    const description = hub.querySelector('[data-ee-description]');
    const faqTarget = hub.querySelector('[data-ee-description-faq]');
    // Reuse the comparison copy and link in the second column without its original callout frame.
    const comparisonLabel = description && [...description.querySelectorAll('strong')].find(el => /^Flash or Hillii\?$/i.test(el.textContent.trim()));
    if (comparisonLabel && factsColumn) {
      const paragraph = comparisonLabel.closest('p');
      if (paragraph) {
        const frame = paragraph.parentElement;
        const comparison = document.createElement('section');
        comparison.className = 'ee-comparison ee-copy';
        const heading = document.createElement('h3');
        heading.textContent = comparisonLabel.textContent;
        comparisonLabel.remove();
        paragraph.removeAttribute('style');
        comparison.append(heading, paragraph);
        if (frame !== description && !frame.textContent.trim()) frame.remove();
        factsColumn.prepend(comparison);
      }
    }

    if (description && faqTarget) {
      const heading = [...description.querySelectorAll('h2,h3,h4')].find(h => /frequently asked questions/i.test(h.textContent));
      if (heading) {
        let wrapper = heading;
        while (wrapper.parentElement && wrapper.parentElement !== description) wrapper = wrapper.parentElement;
        if (hub.querySelector('[data-ee-json-faq]')) {
          if (wrapper !== heading) wrapper.hidden = true;
          else {
            const fragment = document.createElement('div');
            while (heading.nextSibling) fragment.append(heading.nextSibling);
            fragment.hidden = true; heading.replaceWith(fragment);
          }
        } else if (wrapper !== heading) {
          const article = document.createElement('article');
          article.dataset.eeTopic = ''; article.id = `${hub.id}-original-faq`;
          const title = document.createElement('h3'); title.textContent = heading.textContent;
          article.append(title, wrapper); heading.hidden = true;
          faqTarget.replaceWith(article);
        }
      }
    }

    if(description&&hub.classList.contains('ee-study-hub')){
      const blocks=[...description.children].filter(el=>!el.hidden);
      if(blocks.length>1){
        const left=document.createElement('div'),right=document.createElement('div');left.className='ee-description-column';right.className='ee-description-column';
        const split=Math.ceil(blocks.length/2);blocks.forEach((block,index)=>(index<split?left:right).append(block));description.append(left,right);description.classList.add('ee-description-grid');
      }
    }
    panels.forEach(panel => {
      const nav = panel.querySelector('[data-ee-topic-nav]');
      if (!nav) return;
      const topics = [...panel.querySelectorAll('[data-ee-topic]')];
      const buttons = [];
      const mobileLabel=document.createElement('label');mobileLabel.className='ee-topic-picker';mobileLabel.textContent='Choose a topic';
      const mobileSelect=document.createElement('select');mobileLabel.append(mobileSelect);nav.after(mobileLabel);
      const select = index => topics.forEach((topic, i) => {
        topic.hidden = i !== index; topic.inert = i !== index;
        buttons[i].setAttribute('aria-pressed', String(i === index));
      });
      topics.forEach((topic, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = topic.querySelector('h3')?.textContent || '';
        button.setAttribute('aria-controls', topic.id);
        button.addEventListener('click', e => {e.stopPropagation();select(i);mobileSelect.value=String(i);});
        const option=document.createElement('option');option.value=String(i);option.textContent=button.textContent;mobileSelect.append(option);
        buttons.push(button);
        nav.append(button);
        topic.addEventListener('shopify:block:select', () => { showPanel(panel); select(i); });
      });
      mobileSelect.addEventListener('change',()=>select(Number(mobileSelect.value)));
      if (topics.length) select(0);
      else {
        const tab = tabs.find(tab => tab.dataset.eeTarget === `#${panel.id}`);
        if (tab && !window.Shopify?.designMode) tab.hidden = true;
      }
    });
    function showPanel(panel) {
      const nav = hub.querySelector(".ee-tabs");
      const top = nav.getBoundingClientRect().top;
      const preservePosition = hub.classList.contains("is-enhanced") && top >= 0 && top < innerHeight;
      const stack=hub.querySelector('.ee-panel-stack');
      if(stack)stack.style.minHeight='';
      panels.forEach(p => { p.hidden = p !== panel; p.inert = p !== panel; });

      tabs.forEach(tab => {
        const selected = tab.dataset.eeTarget === `#${panel.id}`;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      if (preservePosition) {
        const shift = nav.getBoundingClientRect().top - top;
        if (Math.abs(shift) > 0.5) window.scrollBy({top:shift,behavior:"instant"});
      }
    }
    hub.querySelector('.ee-tabs').setAttribute('role', 'tablist');
    tabs.forEach((tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.id = `${hub.id}-tab-${i}`;
      const panel = panels.find(p => `#${p.id}` === tab.dataset.eeTarget);
      if (!panel) return;
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('pointerdown',e=>{if(e.button===0){e.preventDefault();}});
      tab.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); showPanel(panel); const offset=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ee-header-offset'))||144;window.scrollTo({top:window.scrollY+hub.getBoundingClientRect().top-offset,behavior:'instant'}); });
      tab.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        const visible = tabs.filter(t => !t.hidden);
        const index = visible.indexOf(tab);
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? visible.length - 1 : (index + (e.key === 'ArrowRight' ? 1 : -1) + visible.length) % visible.length;
        visible[next].click(); visible[next].focus({preventScroll:true});
      });
      panel.addEventListener('shopify:block:select', () => showPanel(panel));
    });
    if (panels.length) showPanel(panels[0]);
    const stack=document.createElement('div');stack.className='ee-panel-stack';panels[0].before(stack);panels.forEach(panel=>stack.append(panel));
    hub.classList.add('is-enhanced');
  }
  function revealStatements(root) {
    root.querySelectorAll('.ee-statement-copy').forEach(copy => {
      if(copy.dataset.revealReady || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      copy.dataset.revealReady='true';
      const heading=copy.querySelector('h2');
      if(heading){const text=heading.textContent.trim();heading.setAttribute('aria-label',text);heading.replaceChildren();text.split(/\s+/).forEach((word,i)=>{const span=document.createElement('span');span.className='ee-quote-word';span.setAttribute('aria-hidden','true');span.textContent=word;span.style.setProperty('--word-delay',`${i*65}ms`);heading.append(span,document.createTextNode(' '));});}
      const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){copy.classList.add('is-visible');observer.disconnect();}}, {threshold:0.12});
      copy.classList.add('ee-reveal-ready');observer.observe(copy.querySelector('h2') || copy);
    });
  }
  const scan = root => { revealStatements(root); polishProducts(root); productInteractions(root); root.querySelectorAll('[data-ee-hub]').forEach(init); };
  if (!window.eeEditorialInitialized) {
    window.eeEditorialInitialized = true;
    document.addEventListener('shopify:section:load', e => scan(e.target));
  }
  scan(document);
})();
